export enum DisplayDevice {
	Screen = 'screen',
	Tablet = 'tablet',
	Mobile = 'mobile',
}
